export default "__VITE_ASSET__ee4ea9ec__"